import { Product } from '../models/product';
import Departments from '../models/departments';
import { buildBrandUrlWithCategory } from './routes';
import { Category } from '../models/category';

const isHiddenCategory = (category: Category): boolean =>
  parseInt(category.presentationWeight, 10) <= 0 || parseInt(category.presentationWeight, 10) > 3;

export const buildBreadcrumbs = (
  category: any,
  categories: any,
  mainDepartment: string,
  localized: any,
  product?: Product,
) => {
  const setParentPath = (cat, path) => {
    if (cat.parentId) {
      const parentCategory = categories.find(c => c.id === cat.parentId);
      setParentPath(parentCategory, path);
      if (!isHiddenCategory(parentCategory)) {
        path.push({
          id: parentCategory.id,
          label: parentCategory.name,
          url: localized(parentCategory.url),
        });
      }
    }
    return path;
  };

  const path = [
    {
      id: '',
      label: 'Home',
      url: localized(),
    },
  ];

  if (!category && mainDepartment) {
    path.push({
      id: '',
      label: mainDepartment,
      url: localized(`/${mainDepartment}/`),
    });
    return path;
  }

  if (
    category &&
    mainDepartment &&
    (mainDepartment.toLowerCase() === 'kids' ||
      Departments.getKidsDepartmentsInternalNames().includes(mainDepartment.toLowerCase()))
  ) {
    path.push({
      id: '',
      label: 'Kids',
      url: localized('/kids/'),
    });
  }

  const currentCat = categories.find(c => c.id === category);
  if (currentCat) {
    setParentPath(currentCat, path);
    if (!isHiddenCategory(currentCat)) {
      path.push({
        id: currentCat.id,
        label: currentCat.name,
        url: localized(currentCat.url),
      });
    }
  }
  if (product) {
    path.push({
      id: product.brand.id,
      label: product.brand.name,
      url: localized(
        buildBrandUrlWithCategory({
          brandUrl: product.brand.url,
          categoryId: currentCat.id,
          department: currentCat.department.internalName,
        }),
      ),
    });
    path.push({
      id: product.productVersionId,
      label: product.model,
      url: null,
    });
  }
  return path;
};
